import request from '@/api/request'

export default {
  searchLocation (query) {
    const url = `/location/search?query=${query}`
    return request({ method: 'GET', url })
  },

  searchCities (payload) {
    const url = `/location/search?country=${payload.country}&query=${payload.query}`
    return request({ method: 'GET', url })
  },

  getCountries () {
    const url = `/location/countries`
    return request({ method: 'GET', url })
  }
}
